import { render } from "./ScrollTopButton.vue?vue&type=template&id=5e90edde"
import script from "./ScrollTopButton.vue?vue&type=script&lang=js"
export * from "./ScrollTopButton.vue?vue&type=script&lang=js"

import "./ScrollTopButton.vue?vue&type=style&index=0&id=5e90edde&lang=css"

import exportComponent from "C:\\MesProjets\\Labs\\akdevmatik\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__